import HttpFactory from '@/mixins/http.factory';
export default {
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			linkData:{taskId:null}
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
			});
		},
		linkTaskFn(){
			let _self=this;
			_self.fn().clearMessage();
			let data=_self.linkData;
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.taskUrl=data.taskId;
			let taskId=data.taskId;
			if(data.taskId && data.taskId.endsWith('/')){
                data.taskId=data.taskId.substr(0,data.taskId.length-1);
            }
            if(data.taskId.indexOf('https')>=0 && data.taskId.indexOf('https://app.asana.com/0/')>=0){
                taskId=data.taskId.split('/')[data.taskId.split('/').length-1];
            }
			var url=`zendesk/link/${_self.zendeskInfo.ticket.id}/${encodeURIComponent(taskId)}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					_self.data=response.data.Data;
					_self.sendDataToParent(response.data);
				}else{
					_self.showNotFoundError(response.data.Data);
				}
				
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.showNotFoundError('Asana Task # not found');
				//_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');
		},
		showNotFoundError(msg){
			let _self=this;
			_self.userMsg={show:true,type:'danger',list:[msg]};
		}
	}
}

